// Köfteci Sadullah - Restaurant Data

export const metadata = {
  title: "Köfteci Sadullah | Balıkesir'in Meşhur Köftesi",
  description:
    "Balıkesir'in meşhur köftesi Köfteci Sadullah'ta. Izgara köfte, sucuk ve yöresel lezzetler.",
  robots: "index, follow",
};

export const restaurantInfo = {
  name: "Köfteci Sadullah",
  tagline: "Balıkesir'in Efsane Lezzeti",
  since: "2011",
  description: "Kuşaktan kuşağa aktarılan usta eli, gerçek mangal ateşi ve Balıkesir'in en seçkin etleri ile hazırlanan köftelerimiz, damağınızda unutulmaz bir tat bırakır.",
  instagram: "@koftecisadullah",
  facebook: "Köfteci Sadullah",
  website: "koftecisadullah.com.tr"
};

export const branches = [
  {
    id: 1,
    name: "Ana Şube - Ayşebacı",
    address: "Ayşebacı Mahallesi, 10100 Altıeylül/Balıkesir",
    phone: "+90 536 988 80 67",
    hours: "Her gün 12:00 - 22:00",
    mapUrl: "https://maps.google.com/?q=Köfteci+Sadullah+Balıkesir",
    virtualTourUrl: "https://mls.kuu.la/share/collection/7H3Jp?fs=1&vr=1&initload=0&thumbs=1",
    isMain: true
  },
  {
    id: 2,
    name: "Avlu Şube",
    address: "Avlu AVM, Gümüşçeşme, Laleli Sk. No:50/A, 10020 Altıeylül/Balıkesir",
    phone: "+90 532 558 83 10",
    hours: "Her gün 12:00 - 22:00",
    mapUrl: "https://maps.google.com/?q=Köfteci+Sadullah+Avlu+Balıkesir",
    virtualTourUrl: "https://mls.kuu.la/share/collection/7H3FD?fs=1&vr=1&initload=0&thumbs=1",
    isMain: false
  }
];

export const menuCategories = [
  {
    id: "izgara",
    name: "Izgara Çeşitleri",
    description: "Mangal ateşinde özenle pişirilen lezzetler"
  },
  {
    id: "yanlar",
    name: "Lezzet Eşlikçileri",
    description: "Yemeklerinize eşlik eden geleneksel tatlar"
  },
  {
    id: "tatli",
    name: "Tatlı Çeşitleri",
    description: "Yemeğin ardından tatlı bir son"
  },
  {
    id: "icecek",
    name: "İçecekler",
    description: "Serinleten ve ferahlatan içecekler"
  }
];

export const menuItems = [
  {
    id: 1,
    categoryId: "izgara",
    name: "Sucuk Köfte",
    description: "Özel baharatlarla hazırlanmış, mangalda pişirilmiş el yapımı köfte",
    price: "650₺",
    calories: 480,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/9ehq07jl_ChatGPT%20Image%2017%20Oca%202026%2023_17_25.png"
  },
  {
    id: 2,
    categoryId: "izgara",
    name: "Balıkesir Köfte",
    description: "Özel kesim dana etinden hazırlanan ev yapımı köfte",
    price: "600₺",
    calories: 420,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/dhsxghkk_ChatGPT%20Image%2017%20Oca%202026%2023_21_03.png"
  },
  {
    id: 3,
    categoryId: "izgara",
    name: "Sucuk Izgara",
    description: "Balıkesir'in meşhur acılı sucuğu, mangalda közlenmiş",
    price: "650₺",
    calories: 510,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/5yybpo1s_ChatGPT%20Image%2017%20Oca%202026%2023_44_34.png"
  },
  {
    id: 16,
    categoryId: "izgara",
    name: "Osmanlı Sucuğu",
    description: "Özel baharatlı, geleneksel tarif ile hazırlanmış premium sucuk",
    price: "650₺",
    calories: 530,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/er9nxjor_ChatGPT%20Image%2017%20Oca%202026%2023_24_19.png"
  },
  {
    id: 4,
    categoryId: "izgara",
    name: "Tavuk Izgara",
    description: "Marine edilmiş tavuk, pilav ve garnitür eşliğinde",
    price: "500₺",
    calories: 380,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/r0v38pl0_ChatGPT%20Image%2017%20Oca%202026%2023_46_10.png"
  },
  {
    id: 25,
    categoryId: "izgara",
    name: "Az Tavuk Izgara",
    description: "Az porsiyon marine edilmiş tavuk, pilav ve garnitür eşliğinde",
    price: "300₺",
    calories: 240,
    isSignature: true,
    image: null
  },
  {
    id: 5,
    categoryId: "izgara",
    name: "Köfte-Sucuk Izgara",
    description: "Köfte ve sucuktan oluşan özel seçki",
    price: "650₺",
    calories: 560,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/ca0rsjpg_ChatGPT%20Image%2017%20Oca%202026%2023_26_41.png"
  },
  {
    id: 22,
    categoryId: "izgara",
    name: "1.5 Porsiyon Köfte",
    description: "1.5 porsiyon özel el yapımı köfte, pilav ve garnitür eşliğinde",
    price: "850₺",
    calories: 630,
    isSignature: true,
    image: null
  },
  {
    id: 23,
    categoryId: "izgara",
    name: "1.5 Porsiyon Köfte Sucuk",
    description: "1.5 porsiyon köfte ve sucuktan oluşan özel seçki",
    price: "850₺",
    calories: 720,
    isSignature: true,
    image: null
  },
  {
    id: 24,
    categoryId: "izgara",
    name: "1.5 Porsiyon Tavuk Izgara",
    description: "1.5 porsiyon marine edilmiş tavuk, pilav ve garnitür eşliğinde",
    price: "750₺",
    calories: 540,
    isSignature: true,
    image: null
  },
  {
    id: 13,
    categoryId: "izgara",
    name: "Köfte Ekmek",
    description: "Taze ekmek arasında köfte, yeşillik ve özel soslar (Bütün ekmek: 500₺)",
    price: "300₺",
    calories: 450,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/u2uuc35n_ChatGPT%20Image%2017%20Oca%202026%2023_39_41.png"
  },
  {
    id: 6,
    categoryId: "yanlar",
    name: "Piyaz",
    description: "Kuru fasulye, yumurta, soğan ve özel soslu geleneksel salata",
    price: "200₺",
    calories: 260,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/pcole96x_ChatGPT%20Image%2019%20Oca%202026%2016_46_09.png"
  },
  {
    id: 20,
    categoryId: "yanlar",
    name: "El Yapımı Patates",
    description: "Taze patateslerden günlük hazırlanan, hazır veya dondurulmuş değil, çıtır çıtır kızartma",
    price: "200₺",
    calories: 340,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/x7h3v5pt_ChatGPT%20Image%2020%20Oca%202026%2014_19_05.png"
  },
  {
    id: 21,
    categoryId: "yanlar",
    name: "Etli Çorba",
    description: "Geleneksel tarifle hazırlanan sıcak etli çorba",
    price: "150₺",
    calories: 190,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/pm0tccqw_ChatGPT%20Image%2023%20Oca%202026%2018_05_13.png"
  },
  {
    id: 7,
    categoryId: "yanlar",
    name: "Közlenmiş Biber",
    description: "Mangalda közlenmiş taze sivri biber",
    price: "30₺",
    calories: 25,
    isSignature: false,
    image: null
  },
  {
    id: 8,
    categoryId: "yanlar",
    name: "Közlenmiş Domates",
    description: "Mangalda közlenmiş taze domates",
    price: "30₺",
    calories: 20,
    isSignature: false,
    image: null
  },
  {
    id: 9,
    categoryId: "yanlar",
    name: "Pilav",
    description: "Tereyağlı özel pilav",
    price: "40₺",
    calories: 250,
    isSignature: false,
    image: null
  },
  {
    id: 10,
    categoryId: "tatli",
    name: "Kemalpaşa Tatlısı",
    description: "Şerbetli, fındıklı geleneksel Türk tatlısı (Kaymak ilavesi ile 350₺)",
    price: "200₺",
    calories: 350,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/6xxdz986_ChatGPT%20Image%2017%20Oca%202026%2023_23_01.png"
  },
  {
    id: 11,
    categoryId: "tatli",
    name: "Fırın Sütlaç",
    description: "Fırında pişirilmiş geleneksel sütlaç (Kaymak ilavesi ile 350₺)",
    price: "200₺",
    calories: 280,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/eqwdoq39_ChatGPT%20Image%2019%20Oca%202026%2017_24_22.png"
  },
  {
    id: 12,
    categoryId: "tatli",
    name: "Kaymaklı Ekmek Tatlısı",
    description: "Kaymak ile servis edilen geleneksel ekmek tatlısı (Kaymak ilavesi ile 350₺)",
    price: "200₺",
    calories: 390,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/kpozgtwb_ChatGPT%20Image%2017%20Oca%202026%2023_42_41.png"
  },
  {
    id: 14,
    categoryId: "tatli",
    name: "Kabak Tatlısı",
    description: "Tahinli, cevizli geleneksel kabak tatlısı (Kaymak ilavesi ile 350₺)",
    price: "200₺",
    calories: 310,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/li68ku54_ChatGPT%20Image%2017%20Oca%202026%2023_37_28.png"
  },
  {
    id: 17,
    categoryId: "icecek",
    name: "Cola",
    description: "Soğuk servis edilen Coca-Cola",
    price: "90₺",
    calories: 140,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/od0clg3a_ChatGPT%20Image%2020%20Oca%202026%2014_10_28.png"
  },
  {
    id: 18,
    categoryId: "icecek",
    name: "Fanta",
    description: "Soğuk servis edilen Fanta",
    price: "90₺",
    calories: 160,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/0q7i8glc_ChatGPT%20Image%2020%20Oca%202026%2014_15_16.png"
  },
  {
    id: 19,
    categoryId: "icecek",
    name: "Ayran",
    description: "Taze, köpüklü geleneksel ayran",
    price: "70₺",
    calories: 70,
    isSignature: true,
    image: "https://customer-assets.emergentagent.com/job_turkish-flame/artifacts/lk2u27f8_ChatGPT%20Image%2020%20Oca%202026%2014_08_02.png"
  },
  {
    id: 26,
    categoryId: "icecek",
    name: "Şalgam",
    description: "Geleneksel fermente şalgam suyu",
    price: "90₺",
    calories: 45,
    isSignature: true,
    image: null
  },
  {
    id: 27,
    categoryId: "icecek",
    name: "Limonata",
    description: "Taze sıkılmış ev yapımı limonata",
    price: "90₺",
    calories: 120,
    isSignature: true,
    image: null
  }
];

export const heroImages = {
  background: "https://images.unsplash.com/photo-1589854880846-842b8fe2ba4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjaGFyY29hbCUyMGdyaWxsfGVufDB8fHx8MTc2ODY4Nzk0OHww&ixlib=rb-4.1.0&q=85",
  embers: "https://images.unsplash.com/photo-1586058584813-3e324b9f9aee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxmaXJlJTIwZW1iZXJzfGVufDB8fHx8MTc2ODY4Nzk1M3ww&ixlib=rb-4.1.0&q=85"
};

export const testimonials = [
  {
    id: 1,
    name: "Mehmet Y.",
    text: "Balıkesir'e her geldiğimde mutlaka uğradığım yer. Köftenin tadı yıllardır hiç değişmedi, hala aynı lezzet!",
    rating: 5,
    location: "İstanbul"
  },
  {
    id: 2,
    name: "Ayşe K.",
    text: "Piyazı ve köftesi efsane. Aile ortamı, samimi hizmet. Kesinlikle tavsiye ediyorum.",
    rating: 5,
    location: "İzmir"
  },
  {
    id: 3,
    name: "Ali D.",
    text: "Gerçek mangal lezzeti arayanlar için mükemmel bir adres. Sucuğu da harika!",
    rating: 5,
    location: "Ankara"
  }
];

export const features = [
  {
    id: 1,
    title: "Kuşaklar Boyu Gelenek",
    description: "1985'ten bu yana aynı özenle hazırlanan tarifler"
  },
  {
    id: 2,
    title: "Gerçek Mangal Ateşi",
    description: "Meşe kömüründe, ustalıkla pişirilen lezzetler"
  },
  {
    id: 3,
    title: "Taze Malzemeler",
    description: "Her gün taze, yerel ve kaliteli malzemeler"
  },
  {
    id: 4,
    title: "Balıkesir Ruhu",
    description: "Geleneksel Balıkesir misafirperverliği"
  }
];
